import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons';
import { TextField } from '@nexelem/components';

export type SearchChipProps = {
  placeholder: string;
  onChange?: (value: string) => void;
  value?: string;
  className?: string;
  width?: string;
};

export const SearchChip = ({ placeholder, onChange, value, className, width }: SearchChipProps) => (
  <TextField
    enableClearButton
    className={className}
    inputClassName="rounded-md outline-transparent not-placeholder-shown:bg-surface-focus-lighter not-placeholder-shown:outline-border-focus-lighter hover:bg-surface-hover-lighter hover:outline-border-hover-lighter focus:bg-surface-focus-lighter focus:outline-1 focus-visible:outline-border-focus-lighter"
    placeholder={placeholder}
    size="small"
    StartIcon={() => <FontAwesomeIcon className="min-h-5 min-w-5 text-icon-primary" icon={faMagnifyingGlass} />}
    value={value}
    width={width}
    onChange={onChange}
  />
);
